var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PointRuleList'
      }
    }
  }, [_vm._v("入點比例管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PointRuleList'
      }
    }
  }, [_vm._v("入點比例列表")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("入點比例內容")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("入點比例內容")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('b-table-simple', {
    attrs: {
      "hover": "",
      "small": "",
      "caption-top": "",
      "responsive": "",
      "col-12": "",
      "col-xl-8": ""
    }
  }, [_c('b-tbody', [_c('b-tr', [_c('b-th', [_vm._v("比對值")]), _c('b-td', [_vm._v(_vm._s(_vm.form.key))])], 1), _c('b-tr', [_c('b-th', [_vm._v("點數/倍數")]), _c('b-td', [_vm._v(_vm._s(_vm.form.value))])], 1), _c('b-tr', [_c('b-th', [_vm._v("比對值類型")]), _c('b-td', [_vm._v(_vm._s(_vm.form.type))])], 1), _c('b-tr', [_c('b-th', [_vm._v("活動代碼")]), _c('b-td', [_vm._v(_vm._s(_vm.form.event_id))])], 1), _c('b-tr', [_c('b-th', [_vm._v("順序")]), _c('b-td', [_vm._v(_vm._s(_vm.form.order))])], 1), _c('b-tr', [_c('b-th', [_vm._v("分類")]), _c('b-td', [_vm._v(_vm._s(_vm.form.cate))])], 1)], 1)], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }